import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../../Resolve';
import { Roles } from '../../../common';

const states: Ng1StateDeclaration[] = [{
    name: 'tagsStatistics',
    url: '/tagsStatistics/:beginDate/:endDate',
    component: 'wtTagsStatisticsState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve([
            Roles.master, Roles.engineer, Roles.operator, Roles.reader
        ]),
        dates: Resolve.datesResolve
    },
    data: {
        sortingOrder: -1,
        icon: 'fa-bar-chart',
        displayName: 'Tags statistics',
        editRoles: [Roles.master, Roles.engineer],
        editButtonVisibility: () => true
    },
    params: {
        tag: null,
        beginDate: '',
        endDate: '',
        hideHeaders: false
    }
}];

export default states;